import './depot_controls_component.scss'
import { Controller } from 'stimulus'
import { zoomIn, zoomOut } from 'relation-map/interaction'

export default class extends Controller {
  zoomIn = (): void => {
    zoomIn()
  }

  zoomOut = (): void => {
    zoomOut()
  }
}
